import React from "react"
import { Header } from "./Header"
import { Features } from "./Features"
import { About } from "./About"
import { Services } from "./Services"
import { Gallery } from "./Gallery"
import { Testimonials } from "./Testimonials"
import { Team } from "./Team"
import { FAQ } from "./FAQ"
import { Footer } from "./Footer"
import { WhyUs } from "./WhyUs"
import { Pricing } from "./Pricing"
import { Articles } from "./Articles"
import { Contact } from "./internal/Contact"
import { Products } from "./Products"
import { InquiryWizard } from "./InquiryWizard"
import { ScrollExtras } from "./ScrollExtras"
import { useReveal } from "../hooks/useReveal"
import { UserProfile, ActiveView } from "../types/objects"

export const LANDING_ROOT_ID = "landing-root"

export interface LandingPageData {
    Header?: any
    Features?: any
    About?: any
    WhyUs?: any
    Process?: any
    Pricing?: any
    Articles?: any
    Services?: any
    Gallery?: any
    Testimonials?: any
    Team?: any
    Contact?: any
}

interface LandingPageProps {
    data: LandingPageData
    user: UserProfile | null
    setView: (view: ActiveView) => void
}

/**
 * Public landing page: section order, scroll-reveal animations and scroll helpers.
 */
export const LandingPage: React.FC<LandingPageProps> = ({ data, user, setView }) => {
    useReveal(LANDING_ROOT_ID)

    return (
        <div className="landing-page" id={LANDING_ROOT_ID}>
            <ScrollExtras />
            <Header data={data.Header} user={user} setView={setView} />
            <Features data={data.Features} />
            <About data={data.About} />
            <Services data={data.Services} />
            <Products />
            <InquiryWizard />
            <WhyUs data={data.WhyUs} />
            <Pricing process={data.Process} pricing={data.Pricing} />
            <Gallery data={data.Gallery} />
            <Testimonials data={data.Testimonials} />
            <Team data={data.Team} />
            <Articles data={data.Articles} />
            <Contact data={data.Contact} />
            <FAQ />
            <Footer data={data.Contact} />
        </div>
    )
}
